<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-6">
                        <h1>Report: Attended Jobs Missing a Job Sheet</h1>
                        <p>Jobs listed here have been attended and have either no forms at all or have a Fire Alarm Form but no Job Sheet</p>
                    </div>
                    <div class="col-6 text-right search-right">
                        <label>
                            Show only attended jobs
                            <input
                                type="checkbox"
                                v-model="attendedOnly"
                                @change="loadReport"
                            >
                        </label>
                        <label>
                            Include checked jobs 
                            <input
                                type="checkbox"
                                v-model="incChecked"
                                @change="loadReport"
                            >
                        </label>
                        <span v-if="!loading">Total:
                            <span
                                class="badge badge-danger"
                                style="font-size: 1rem;"
                            >{{ jobs.length }}</span>
                        </span>
                        <button
                            class="btn btn-primary"
                            @click="loadReport"
                        >
                            Refresh
                            <i
                                class="fa fa-sync-alt"
                                :class="{'fa-spin': loading}"
                                :disabled="loading"
                            />
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <p
                            v-if="loading"
                            class="alert alert-primary"
                        >
                            Loading, please wait...
                        </p>
                        <p
                            v-if="!loading && jobs.length == 0"
                            class="alert alert-success"
                        >
                            No jobs in this report
                        </p>
                        <table
                            v-if="jobs.length > 0 && !loading"
                            class="table"
                        >
                            <thead>
                                <tr>
                                    <th>Job ID</th>
                                    <th>Job Name</th>
                                    <th>Customer</th>
                                    <th>Attended At</th>
                                    <th>Attended By</th>
                                    <th>Created At</th>
                                    <th>Updated At</th>
                                    <th>Checked</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(job, index) in jobs"
                                    :key="job.id"
                                >
                                    <td>
                                        <router-link :to="{ name: 'office.jobs.show', params: { id: job.id } }">
                                            {{ job.id }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <router-link :to="{ name: 'office.jobs.show', params: { id: job.id } }">
                                            {{ job.name }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <router-link :to="{ name: 'office.customers.show', params: { id: job.customer_id } }">
                                            {{ job.customer.company_name }}
                                        </router-link>
                                    </td>
                                    <td>{{ job.attended_at | datetime }}</td>
                                    <td>
                                        <span v-if="job.attended_by">{{ job.attended_by.name }}</span>
                                        <span v-else>-</span>
                                    </td>
                                    <td>{{ job.created_at | datetime }}</td>
                                    <td>{{ job.updated_at | datetime }}</td>
                                    <td class="text-right">
                                        <input
                                            type="checkbox"
                                            :checked="job.handover_form_checked_by !== null"
                                            @input="triggerCheckedBy($event, job, index)"
                                        >
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import JobsService from "../../../services/JobService";

export default {
    data() {
        return {
            loading: false,
            jobs: [],
            attendedOnly: true,
            incChecked: false,
        };
    },
    mounted() {
        this.loadReport();
    },
    methods: {
        loadReport() {
            this.loading = true;
            JobsService.reportMissingHandover({attended_only: this.attendedOnly, inc_checked: this.incChecked})
                .then(({ data }) => {
                    this.jobs = data;
                })
                .catch(err => {
                    window.alert(
                        "Error: Failed to load report please try again"
                    );
                    throw err;
                })
                .then(() => {
                    this.loading = false;
                });
        },
        triggerCheckedBy ($event, job, index) {
            var value = $event.target.checked;
            JobsService.handoverChecked(job, value).then(res => {
                this.jobs[index] = res.data;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.search-right {
    vertical-align: middle;

    label {
        margin-right: 1em;

        input {
            vertical-align: middle;
        }
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/office/jobs/ReportMissingHandoverComponent.vue